var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTelStoresOfferTips(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1 3C1 2.46957 1.21071 1.96086 1.58579 1.58579C1.96086 1.21071 2.46957 1 3 1H3.91467C4.488 1 4.988 1.39067 5.12733 1.94667L5.864 4.89533C5.9237 5.134 5.91164 5.38497 5.82934 5.61682C5.74704 5.84866 5.59815 6.05106 5.40133 6.19867L4.53933 6.84533C4.44933 6.91267 4.43 7.01133 4.45533 7.08C4.83159 8.10323 5.42573 9.03247 6.19663 9.80337C6.96753 10.5743 7.89677 11.1684 8.92 11.5447C8.98867 11.57 9.08667 11.5507 9.15467 11.4607L9.80133 10.5987C9.94894 10.4018 10.1513 10.253 10.3832 10.1707C10.615 10.0884 10.866 10.0763 11.1047 10.136L14.0533 10.8727C14.6093 11.012 15 11.512 15 12.086V13C15 13.5304 14.7893 14.0391 14.4142 14.4142C14.0391 14.7893 13.5304 15 13 15H11.5C5.70133 15 1 10.2987 1 4.5V3Z",
    fill: "#1C7A9E"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTelStoresOfferTips);
export default __webpack_public_path__ + "static/media/tel_stores-offer-tips.fff04e118364b4f8723344ff65fa3996.svg";
export { ForwardRef as ReactComponent };